import { render } from "./BadgeMartriculaStatus.vue?vue&type=template&id=eb917e4a"
import script from "./BadgeMartriculaStatus.vue?vue&type=script&lang=js"
export * from "./BadgeMartriculaStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__